import { useReducer } from 'react';

function reducer(state, { type, message, result }) {
  switch (type) {
    case 'SUBMIT_ERROR':
      return {
        ...state,
        error: message,
        result: null,
      };
    case 'SUBMIT_COMPLETE':
      return {
        ...state,
        error: null,
        result,
      };
    default:
      return {
        ...state,
      };
  }
}

function useSendData({ endpoint }) {
  const [state, dispatch] = useReducer(reducer, {
    error: null,
    result: null,
  });

  async function sendData(body) {
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) throw new Error('There was a problem');

      const result = await response.json();

      dispatch({ type: 'SUBMIT_COMPLETE', result });
    } catch ({ message }) {
      dispatch({ type: 'SUBMIT_ERROR', message });
    }
  }

  return { sendData, state };
}

export default useSendData;
